import { render, staticRenderFns } from "./TitledSection.vue?vue&type=template&id=6eb9b15a&"
import script from "./TitledSection.vue?vue&type=script&lang=ts&"
export * from "./TitledSection.vue?vue&type=script&lang=ts&"
import style0 from "./TitledSection.vue?vue&type=style&index=0&id=6eb9b15a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports